exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.chart-card[data-v-45325cb2] {\r\n    margin-bottom: 20px;\n}\n.card[data-v-45325cb2] {\r\n    background-color: #fff;\r\n    border-radius: 2px;\n}\n.picker[data-v-45325cb2] {\r\n    margin-top: 1em;\n}\r\n", ""]);

// exports
